import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 1,
  class: "ml-3"
}

import { computed, ref, watch, reactive } from 'vue'
import { ApiMap } from "@/api/type";
import { useApi } from "@/api/handler";
import { proposal } from "@/api";
import DynamicForm from '../DynamicForm.vue';
import { game } from '@/api';



export default /*@__PURE__*/_defineComponent({
  __name: 'RankList',
  props: {
    data: {},
    maxHeight: {},
    enableEdit: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const enableEdit = computed(() => props.enableEdit ?? true)

const emits = __emit

const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const scoreList = ref<ApiMap['/proposal/rank/all']['resp']>([])

const rankColors = ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-1']

const sortedList = computed(() =>
  [...scoreList.value].sort((a, b) => b.score - a.score)
)

const submitObject = reactive({
  type: 1,
  showOverlay: false,
  data: {}
})

const useAllRank = () => {
  if (!GameStatus.value) return
  useApi({
    api: proposal.AllRank(GameStatus.value.id),
    onSuccess: resp => {
      scoreList.value = resp.data as ApiMap['/proposal/rank/all']['resp']
    }
  })
}

function handleRowClick(item: any, index: number) {
  emits('click', { item, index })
  if (!enableEdit.value) return;
  if (!GameStatus.value) return;
  submitObject.data = {
    type: submitObject.type,
    stage: 2,
    id: item.teamId,
    gameId: GameStatus.value.id,
    num: 0,
    comment: ""
  }
  submitObject.showOverlay = true
}

function useSubmitScoreEditor(data: ApiMap['/game/score/update']['req']) {
  console.log(data)
  useApi({
    api: game.SubmitScoreEditor(data),
    Finally: () => { submitObject.showOverlay = false },
    onSuccess: () => {
      submitObject.showOverlay = false
      useAllRank()
    },
    tip: '更改成功'
  })
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
  useAllRank()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      rounded: "",
      "max-height": _ctx.maxHeight ?? 400,
      "max-width": "800",
      "min-width": "500"
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-lg-h6 px-4 py-2 bg-indigo-lighten-2" }, " 提案赛阶段小组积分排行榜 ", -1)),
        _createElementVNode("div", {
          class: "ml-2",
          style: _normalizeStyle(`overflow-y: auto; height:${_ctx.maxHeight - 50}px;`)
        }, [
          _createVNode(_component_v_table, {
            density: "compact",
            class: "rounded"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "排名"),
                  _createElementVNode("th", null, "组号"),
                  _createElementVNode("th", null, "姓名"),
                  _createElementVNode("th", null, "得分")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.teamId,
                    onClick: ($event: any) => (handleRowClick(item, index)),
                    style: {"cursor":"pointer"}
                  }, [
                    _createElementVNode("td", null, [
                      (index < 3)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            color: rankColors[index],
                            "text-color": "white",
                            density: "compact",
                            small: "",
                            label: "",
                            class: "font-weight-bold"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 第 " + _toDisplayString(index + 1) + " 名 ", 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "第 " + _toDisplayString(index + 1) + " 名", 1))
                    ]),
                    _createElementVNode("td", null, "第 " + _toDisplayString(item.teamId) + " 组", 1),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.score), 1)
                  ], 8, _hoisted_1))
                }), 128))
              ])
            ]),
            _: 1,
            __: [2]
          })
        ], 4)
      ]),
      _: 1,
      __: [3]
    }, 8, ["max-height"]),
    _createVNode(_component_v_overlay, {
      modelValue: submitObject.showOverlay,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((submitObject.showOverlay) = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(DynamicForm, {
          model: submitObject.data,
          title: "请输入小组积分变更",
          headers: ['', '', '', '', '小组分数变更', '评论'],
          "excluded-keys": ['type', 'stage', 'id', 'gameId'],
          onSubmit: useSubmitScoreEditor,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (submitObject.showOverlay = false))
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})